import React from 'react'
import Button from 'material-ui/Button'
import Icon from 'material-ui/Icon'
import Tooltip from 'material-ui/Tooltip'
import { withStyles } from 'material-ui/styles'

import styles from '../styles'
class Toolbar extends React.Component {

  render() {

    const {
      classes,
      toggleLock,
      toggleStolen,
      translate,
      device,
      isIdealAdmin,
      showModal
    } = this.props

    return (
      <div>
        {isIdealAdmin && (
          <Tooltip title={translate("tooltip_search")}>
            <Button className={classes.button} color="accent" fab mini onClick={() => showModal()}>
              <Icon>search</Icon>
            </Button>
          </Tooltip>
        )}
        {false && (<React.Fragment>
          <Tooltip title={translate("report_stolen_device")}>
            <Button className={classes.button} color="accent" fab mini onClick={() => toggleStolen()}>
              <Icon>pan_tool</Icon>
            </Button>
          </Tooltip>

          {!device.isstolen && (
            <Tooltip title={device.islocked ? (translate("unlock_device")) : (translate("lock_device"))}>
              <Button className={classes.button} color="accent" fab mini onClick={() => toggleLock()}>
                <Icon>{device.islocked ? 'lock' : 'lock_open'}</Icon>
              </Button>
            </Tooltip>
          )}
        </React.Fragment>)
        }
      </div >
    )
  }
}


export default withStyles(styles)(Toolbar)



// WEBPACK FOOTER //
// ./src/components/device/toolbar/index.js